import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DeviationSuggestionReasons } from '../../../../../../types/deviation';
import { getSuggestionReasonsByPriority } from '../../../../../_helpers';
import s from './ThumbLabel.scss';
function useReasonText(deviation) {
    var t = useTranslation().t;
    var reason = getSuggestionReasonsByPriority(deviation)[0];
    switch (reason) {
        case DeviationSuggestionReasons.Recommended:
            return '';
        case DeviationSuggestionReasons.WatchingUser:
            return t('deviationview.overlay.reasons.watchingUser');
        case DeviationSuggestionReasons.WatchingGroup:
            return t('deviationview.overlay.reasons.watchingGroup');
        case DeviationSuggestionReasons.WatchingTopic:
            return t('deviationview.overlay.reasons.watchingTopic');
        case DeviationSuggestionReasons.NewDeviant: // has no text spec'd yet
        case DeviationSuggestionReasons.Popular: // has no text spec'd yet
        case DeviationSuggestionReasons.DailyDeviation: // does not have a text label
        default:
    }
}
var ThumbLabel = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var reason = useReasonText(deviation);
    if (!reason) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['label'], className), "augmented-ui": "tl-clip br-clip exe" }, reason));
};
ThumbLabel.displayName = 'ThumbLabel';
export default ThumbLabel;
//# sourceMappingURL=ThumbLabel.js.map